"use client"

import { twMerge } from "tailwind-merge"
import Logo from "@components/Logo"
import Link from "next/link"
import Hamburger from "@components/Hamburger"
import { useState, useEffect } from "react"
import { LazyMotion, domAnimation, m, AnimatePresence } from "framer-motion"
import clsx from "clsx/lite"
import Houzz from "@icons/Houzz.svg?react"
import LinkedIn from "@icons/LinkedIn.svg?react"
import Pinterest from "@icons/Pinterest.svg?react"
import Instagram from "@icons/Instagram.svg?react"
import Facebook from "@icons/Facebook.svg?react"
import ChevronRight from "@icons/ChevronRight.svg?react"
import { useClickAway } from "@uidotdev/usehooks"

export default ({ className, links = [], logo = true, full = false }) => {
    const [open, setOpen] = useState(false)
    const [showFull, setShowFull] = useState(false)
    const [section, setSection] = useState(null)

    const menu = useClickAway(() => {
        setOpen(false)
    })

    const toggleSection = (value) => {
        if (section === null) return setSection(value)

        if (section === value) {
            setSection(null)
        }

        setSection(value)
    }

    useEffect(() => {
        setSection(null)
    }, [open])

    useEffect(() => {
        if (window.scrollY > 50) {
            setShowFull(true)
        }

        const handleScroll = () => {
            setShowFull(window.scrollY > 64)
        }

        window.addEventListener("scroll", handleScroll)

        return () => window.removeEventListener("scroll", handleScroll)
    }, [])

    const variants = {
        container: {
            hidden: { opacity: 0 },
            show: {
                opacity: 1,
                transition: {
                    when: "beforeChildren",
                    staggerChildren: 0.2,
                },
            },
            exit: {
                opacity: 0,
            },
        },
        headings: {
            hidden: { opacity: 0, x: 20 },
            show: {
                opacity: 1,
                x: 0,
                transition: {
                    duration: 0.3,
                },
            },
            exit: {
                opacity: 0,
            },
        },
        items: {
            hidden: { opacity: 0 },
            show: {
                opacity: 1,
                transition: {
                    staggerChildren: 0.1,
                    when: "beforeChildren",
                },
            },
            exit: {
                opacity: 0,
            },
        },
    }

    return (
        <div className={clsx("w-full relative", full ? "pb-16 md:pb-0" : "")}>
            <div
                ref={menu}
                className={clsx(
                    "block md:hidden fixed w-full",
                    open ? "z-60" : "z-40",
                )}
            >
                <div
                    className={twMerge(
                        "w-full top-0 left-0 min-h-24 px-(--mobile-padding) relative transition-colors duration-100 [--mobile-padding:--spacing(5)]",
                        full || showFull || open ?
                            "bg-arugula shadow-xl"
                        :   "bg-transparent",
                        className,
                    )}
                >
                    <div className="container max-w-5xl flex py-2 items-center mx-auto justify-end">
                        {(logo || showFull || open) && (
                            <Link
                                href="/"
                                className="-ml-[calc(--mobile-padding-(1rem))] mr-auto"
                            >
                                <Logo
                                    logo="square"
                                    position="left"
                                    subtext={false}
                                />
                            </Link>
                        )}
                        <div className="ml-4 -mr-3 scale-80">
                            <Hamburger
                                toggle={() => setOpen(!open)}
                                toggled={open}
                            />
                        </div>
                    </div>
                </div>
                <LazyMotion features={domAnimation} strict>
                    <AnimatePresence mode="wait">
                        {open && (
                            <m.div
                                variants={variants.container}
                                initial="hidden"
                                animate="show"
                                exit="exit"
                                className="w-full bg-arugula flex flex-col items-end px-10 absolute z-40 gap-5 pb-5"
                            >
                                {/* <m.div
                                    variants={{
                                        hidden: { opacity: 0, y: -20 },
                                        show: {
                                            opacity: 1,
                                            y: 0,
                                            transition: {
                                                duration: 0.3,
                                            },
                                        },
                                    }}
                                    className="flex w-full justify-between py-2"
                                >
                                    <Link
                                        href="#"
                                        target="_blank"
                                        className="my-0.5"
                                        tooltip="Houzz"
                                        tooltip-position="top"
                                        tooltip-background="var(--color-green-multiply)"
                                    >
                                        <Houzz className="size-8 stroke-garden-grove fill-garden-grove hover:fill-white-snow" />
                                    </Link>
                                    <Link
                                        href="#"
                                        target="_blank"
                                        className="my-0.5"
                                        tooltip="LinkedIn"
                                        tooltip-position="top"
                                        tooltip-background="var(--color-green-multiply)"
                                    >
                                        <LinkedIn className="size-8 stroke-garden-grove fill-garden-grove hover:fill-white-snow" />
                                    </Link>
                                    <Link
                                        href="#"
                                        target="_blank"
                                        className="my-0.5"
                                        tooltip="Pinterest"
                                        tooltip-position="top"
                                        tooltip-background="var(--color-green-multiply)"
                                    >
                                        <Pinterest className="size-8 stroke-garden-grove fill-garden-grove hover:fill-white-snow" />
                                    </Link>
                                    <Link
                                        href="#"
                                        target="_blank"
                                        className="my-0.5"
                                        tooltip="Instagram"
                                        tooltip-position="top"
                                        tooltip-background="var(--color-green-multiply)"
                                    >
                                        <Instagram className="size-8 stroke-garden-grove fill-garden-grove hover:fill-white-snow" />
                                    </Link>
                                    <Link
                                        href="#"
                                        target="_blank"
                                        className="my-0.5"
                                        tooltip="Facebook"
                                        tooltip-position="top"
                                        tooltip-background="var(--color-green-multiply)"
                                    >
                                        <Facebook className="size-8 stroke-garden-grove fill-garden-grove hover:fill-white-snow" />
                                    </Link>
                                </m.div> */}

                                {links
                                    .filter((link) => link.mobile)
                                    .map((link) => {
                                        console.log(link)
                                        return link
                                    })
                                    .map(({ name, key, columns }, idx) => (
                                        <m.div
                                            key={name}
                                            variants={variants.headings}
                                            initial="hidden"
                                            animate="show"
                                            exit="exit"
                                        >
                                            <div
                                                className="flex items-center w-full justify-end mb-3"
                                                onClick={() =>
                                                    toggleSection(idx)
                                                }
                                            >
                                                <Link
                                                    href={key}
                                                    className="font-bold text-2xl"
                                                    onClick={(e) => {
                                                        section !== idx ?
                                                            e.preventDefault()
                                                        :   null
                                                    }}
                                                >
                                                    {name}
                                                </Link>
                                                <ChevronRight
                                                    className={clsx(
                                                        "size-5 fill-white-snow ml-2 transition-transform duration-300",
                                                        section === idx ?
                                                            "-rotate-90"
                                                        :   "rotate-90",
                                                    )}
                                                />
                                            </div>
                                            {section === idx && (
                                                <m.div
                                                    className="text-right flex flex-col gap-3"
                                                    initial="hidden"
                                                    animate="show"
                                                    exit="exit"
                                                    variants={variants.items}
                                                >
                                                    {columns
                                                        .flatMap(
                                                            (col) => col.items,
                                                        )
                                                        .filter(
                                                            (link) =>
                                                                link.title !==
                                                                undefined,
                                                        )
                                                        .map(
                                                            (
                                                                { title, href },
                                                                idx,
                                                            ) => (
                                                                <m.div
                                                                    key={`${title}-${idx}`}
                                                                    variants={{
                                                                        hidden: {
                                                                            opacity: 0,
                                                                            y: -10,
                                                                        },
                                                                        show: {
                                                                            opacity: 1,
                                                                            y: 0,
                                                                            transition:
                                                                                {
                                                                                    duration: 0.2,
                                                                                },
                                                                        },
                                                                    }}
                                                                >
                                                                    <Link
                                                                        href={
                                                                            href
                                                                        }
                                                                        className="py-2 font-bold text-base"
                                                                    >
                                                                        {title}
                                                                    </Link>
                                                                </m.div>
                                                            ),
                                                        )}
                                                </m.div>
                                            )}
                                        </m.div>
                                    ))}

                                <m.div
                                    variants={variants.items}
                                    className="my-3"
                                >
                                    <Link
                                        href="contact"
                                        className="font-bold text-2xl py-2 px-4 bg-green-multiply"
                                    >
                                        Contact Us
                                    </Link>
                                </m.div>
                            </m.div>
                        )}
                    </AnimatePresence>
                </LazyMotion>
            </div>
        </div>
    )
}
